/* eslint-disable */

/*
 * This is a generated file created by deere-ui-svg-to-react.
 *
 * Please do not modify this file directly as it will be regenerated at build time.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

exports["default"] = _react2["default"].createClass({
    displayName: "declined",

    getDefaultProps: function getDefaultProps() {
        return {
            "st0": {
                "fill": "#B20000"
            },
            "declined": {
                "backgroundImage": "none",
                "backgroundPosition": "0% 0%",
                "display": "inline",
                "fill": "#333"
            },
            "width": "18",
            "height": "18"
        };
    },

    render: function render() {
        return _react2["default"].createElement(
            "svg",
            { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 18 18", className: "declined", width: this.props.width, height: this.props.height, style: this.props.declined },
            _react2["default"].createElement("path", { className: "st0", d: "M11.1 9l6.4-6.4c.6-.6.6-1.5 0-2.1-.6-.6-1.5-.6-2.1 0L9 6.9 2.6.4C2-.1 1-.1.4.4-.1 1-.1 2 .4 2.6L6.9 9 .5 15.4c-.6.6-.6 1.5 0 2.1.2.4.6.5 1 .5s.8-.1 1.1-.4L9 11.1l6.4 6.4c.3.3.7.4 1.1.4s.8-.1 1.1-.4c.6-.6.6-1.5 0-2.1L11.1 9z", style: this.props.st0 })
        );
    }
});

/* eslint-enable */
module.exports = exports["default"];



// WEBPACK FOOTER //
// ./~/cap-it-ui.toggles/~/cap-it-ui.icons/lib/declined.js